/**
 * @packageDocumentation
 * @module Array
 */
/**
 * Build an array using a function that will give values for each given index.
 * Can be used to create arrays of objects, ensuring each has it's own reference.
 *
 * @template T
 * @param {number} length
 * @param {(i: number) => T} valueGiver
 *
 * @return {T[]}
 */
export var buildArray = function (length, valueGiver) {
    var result = [];
    for (var i = 0; i < length; i += 1) {
        result.push(valueGiver(i));
    }
    return result;
};
//# sourceMappingURL=buildArray.js.map